import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyB31T072mmA22U2ISsT9UaNQZgt9ypNoqQ",
  authDomain: "ideate-app-react.firebaseapp.com",
  databaseURL: "https://ideate-app-react.firebaseio.com",
  projectId: "ideate-app-react",
  storageBucket: "ideate-app-react.appspot.com",
  messagingSenderId: "520960132349",
  appId: "1:520960132349:web:69cbdc8f89043275f12a94",
  measurementId: "G-18RHJ8ZR5Z"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();
